export interface BillingStatus {
  subscriptions: { id: string; status: string; billingInterval: 'month' | 'year'; currentPeriodEndsAt: string | null;
    nextBilledAt: string | null; scheduledCancellationAt: string | null; cancellationRequested: boolean; cancellationPending: boolean }[];
  pendingCheckout: { failureCode?:string|null;transactionId: string | null; billingInterval: string } | null;
}
export interface UsagePeriod { kind: string; startsAt: string; endsAt: string; billingInterval: string | null; entitlementMode: string; videos: number; seconds: number }
export const dateTime = (value: string | null | undefined) => value ? new Date(value).toLocaleString() : '—';
